import React, { useState } from 'react';
import { TextInputProps as RNTextInputProps } from 'react-native';
import { isDefined } from '@app/helpers/kindOf';
import { StyledInputs, StyledTextInputProps } from '../styled/form/Inputs';
import { StyledForms } from '../styled/form/Form';
import { useInput } from '@app/hooks/useInput';
import { HelperText } from '../styled/form/Label';

export interface TextInputProps extends RNTextInputProps, StyledTextInputProps {
  name: string;
  helper?: string;
  label?: string;
}

export const TextInput = ({ label, name, helper, ...props }: TextInputProps) => {
  const { field, error, formState } = useInput(name);

  const [blur, setBlur] = useState(true);

  const onBlur = () => {
    setBlur(true);
  }

  const onFocus = () => {
    setBlur(false);
  }

  const isFilled = isDefined(field.value);

  return (
    <StyledInputs.Holder>
      {label && <StyledInputs.Label isFilled={isFilled} isDirty={formState.isDirty} isBlurred={blur}>
        {label}
      </StyledInputs.Label>}

      {!!error && (
        <StyledForms.Error>
          <StyledForms.ErrorLabel>
            {error}
          </StyledForms.ErrorLabel>
        </StyledForms.Error>
      )}

      <StyledInputs.Input
        onChangeText={field.onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        value={field.value}
        ref={field.ref}
        isBlurred={blur}
        {...props}
      />

      {helper && (
        <HelperText>
          {helper}
        </HelperText>
      )}
    </StyledInputs.Holder>
  );
};
